export default "__VITE_PUBLIC_ASSET__91d9024b__"